import React, { useContext, useEffect } from 'react';
import { useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { UserSessionDetails, UserSessionDetailsContext } from '../../../App';
import FormModal from '../../../modal/FormModal';
import { WorkorderAssignmentWithRate } from './PersonnelTableAdmin';

const queryClient = new QueryClient();

interface PersonnelDeleteModalProps {
    refreshTable: () => void;
    isOpen: boolean;
    closeModal: () => void;
    data: WorkorderAssignmentWithRate;
}

const PersonnelDeleteModal = (props: PersonnelDeleteModalProps): JSX.Element => (
    <QueryClientProvider client={queryClient}>
        <PersonnelDeleteModalInner {...props}/>
    </QueryClientProvider>
)


const PersonnelDeleteModalInner = (props: PersonnelDeleteModalProps): JSX.Element => {
    const sessionDetails: UserSessionDetails = useContext(UserSessionDetailsContext);
    // submit request stuff
    const { data, status, refetch, remove } = useQuery('client_add', async () => {
        const res = await fetch(`${sessionDetails.backend.host}:${sessionDetails.backend.port}/workorder_assignment_with_rate`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                access_token: sessionDetails.access_token,
                req: {
                    workorder_assignment_id: props.data.id,
                    rate_id: props.data.rate_id
                }
            })
        });
        return res.json();
    }, { // options are here so it won't auto-fetch
        refetchOnWindowFocus: false,
        enabled: false, 
    });
    const loading = status !== 'success' || data.STATUS !== 'SUCCESS';

    const onSubmit = () => {
        refetch();
    }

    useEffect(() => {
        if (!loading) {
            remove();
            props.closeModal();
            props.refreshTable();
        }
    }, [loading, props, remove]);
    
    return (
        <FormModal 
            title='Delete Personnel & Rate'
            form_strategy='Delete'
            menuAttributes={[]}
            onClose={props.closeModal}
            isOpen={props.isOpen}
            isSaveButtonDisabled={() => false}
            onSave={onSubmit}
        />
    )
};

export default PersonnelDeleteModal;